import { render } from "./VerificationPending.vue?vue&type=template&id=a97b953a"
import script from "./VerificationPending.vue?vue&type=script&lang=js"
export * from "./VerificationPending.vue?vue&type=script&lang=js"
script.render = render

export default script